module.exports = __webpack_public_path__ + "img/blob1.0c585430.svg";